<template>
   <div class="content-wrapper">
      <div class="jumbotron pt-10 pb-4 pt-md-13 pb-md-6">
         <div class="container container-1200">
            <div class="row">
               <div
                  v-if="
                     privacyPolicyPageData &&
                        privacyPolicyPageData.content &&
                        privacyPolicyPageData.content[0]
                  "
                  class="col-12"
               >
                  <h1 class="text-center">{{ privacyPolicyPageData.content[0].header }}</h1>
                  <div
                     class="pt-6"
                     v-html="markedRender(privacyPolicyPageData.content[0].longDescription)"
                  />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../util/meta.js';

export default {
   name: 'PrivacyPolicy',
   computed: {
      ...mapState(['privacyPolicyPageData']),
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('PRIVACY_POLICY_PAGE_DATA_FETCH')]);
   },

   metaInfo() {
      return metaGenerator(this.privacyPolicyPageData);
   },
};
</script>
